<template>
  <component
    :is="blockComponents[block.component]"
    v-if="blockComponents[block.component]"
    v-bind="block.props"
  />
</template>

<script setup lang="ts">
import BlockHeader from '~/components/blocks/BlockHeader.vue'
import BlockHero from '~/components/blocks/BlockHero.vue'
import BlockFeatures from '~/components/blocks/BlockFeatures.vue'
import BlockFaq from '~/components/blocks/BlockFaq.vue'
import BlockLandingHero from '~/components/blocks/BlockLandingHero.vue'
import BlockProducts from '~/components/blocks/BlockProducts.vue'
import BlockFooter from '~/components/blocks/BlockFooter.vue'
import BlockBlogList from '~/components/blocks/BlockBlogList.vue'
import BlockBanner from '~/components/blocks/BlockBanner.vue'
import BlockServices from '~/components/blocks/BlockServices.vue'
import BlockServiceGroups from '~/components/blocks/BlockServiceGroups.vue'
import BlockAppointment from '~/components/blocks/BlockAppointment.vue'
import BlockBookingWizard from '~/components/blocks/BlockBookingWizard.vue'
import BlockTestimonials from '~/components/blocks/BlockTestimonials.vue'
import BlockDoctorIntro from '~/components/blocks/BlockDoctorIntro.vue'
import BlockHighlights from '~/components/blocks/BlockHighlights.vue'
import BlockCredentials from '~/components/blocks/BlockCredentials.vue'
import BlockReasons from '~/components/blocks/BlockReasons.vue'
import BlockSpecialties from '~/components/blocks/BlockSpecialties.vue'
import BlockCtaBanner from '~/components/blocks/BlockCtaBanner.vue'
import BlockContact from '~/components/blocks/BlockContact.vue'
import BlockTeam from '~/components/blocks/BlockTeam.vue'
import BlockInsurance from '~/components/blocks/BlockInsurance.vue'
import BlockGallery from '~/components/blocks/BlockGallery.vue'
import BlockSpinWheel from '~/components/blocks/BlockSpinWheel.vue'
import BlockFlashSale from '~/components/blocks/BlockFlashSale.vue'
import BlockCampaignBanner from '~/components/blocks/BlockCampaignBanner.vue'
import BlockNewsletterCapture from '~/components/blocks/BlockNewsletterCapture.vue'
import BlockLeadMagnet from '~/components/blocks/BlockLeadMagnet.vue'
import BlockChecklist from '~/components/blocks/BlockChecklist.vue'
import BlockLeadCalculator from '~/components/blocks/BlockLeadCalculator.vue'
import BlockLeadQuiz from '~/components/blocks/BlockLeadQuiz.vue'
import BlockConsultationForm from '~/components/blocks/BlockConsultationForm.vue'
import BlockLeadSurvey from '~/components/blocks/BlockLeadSurvey.vue'
import BlockPersonalizedGuide from '~/components/blocks/BlockPersonalizedGuide.vue'
import BlockEventRegistration from '~/components/blocks/BlockEventRegistration.vue'
import BlockWaitlistForm from '~/components/blocks/BlockWaitlistForm.vue'
import BlockSmartContactForm from '~/components/blocks/BlockSmartContactForm.vue'
import BlockLeadChatWidget from '~/components/blocks/BlockLeadChatWidget.vue'
import type { Component } from 'vue'

defineProps<{
  block: { component: string; props: Record<string, unknown> }
}>()

const blockComponents: Record<string, Component> = {
  BlockHeader,
  BlockHero,
  BlockFeatures,
  BlockFaq,
  BlockLandingHero,
  BlockProducts,
  BlockFooter,
  BlockBlogList,
  BlockBanner,
  BlockServices,
  BlockServiceGroups,
  BlockAppointment,
  BlockBookingWizard,
  BlockTestimonials,
  BlockDoctorIntro,
  BlockHighlights,
  BlockCredentials,
  BlockReasons,
  BlockSpecialties,
  BlockCtaBanner,
  BlockContact,
  BlockTeam,
  BlockInsurance,
  BlockGallery,
  BlockSpinWheel,
  BlockFlashSale,
  BlockCampaignBanner,
  BlockNewsletterCapture,
  BlockLeadMagnet,
  BlockChecklist,
  BlockLeadCalculator,
  BlockLeadQuiz,
  BlockConsultationForm,
  BlockLeadSurvey,
  BlockPersonalizedGuide,
  BlockEventRegistration,
  BlockWaitlistForm,
  BlockSmartContactForm,
  BlockLeadChatWidget,
}
</script>
